import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const DialogContentContainer = styled.div`
    padding: 15px 16px;
`;

export const NoUsageHeader = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const CrossIconImg = styled.img.attrs((props) => ({
    src: props.path,
}))`
    width: 20px;
    height: 20px;
    cursor: pointer;
    align-self: center;
`;

export const NoUsageTitle = styled.div`
    font-family: AvenirNextWorld Demi;
    font-size: 18px;
    letter-spacing: -0.14px;
    color: #140F4B;
    opacity: 1;
    padding: ${(props) => props.padding};
    ${media.mobileDevice`
        font-size: 20px;
        letter-spacing: 0px;
        color: #130E4A;
    `}
`;

export const NoUsageFooterContainer = styled.div`
    background-color: #ffffff;
    position: absolute;
    bottom: ${(props) => (props.isCancelPopup ? '24px' : '35px')};
    right: 0px;
    left: 0px;
    ${media.mobileDevice`
        bottom: 60px;
        right: 0px;
        left: 0px;
    `}
`;

export const NoUsageButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    //justify-content: flex-end;
     justify-content: space-evenly;
     float : right;
    ${media.mobileDevice`
        width: 100%;
        justify-content: space-evenly;
        height: 60px;
        padding-top: 13px;
    `}
`;

export const NoUsageReasonsDiv = styled.div`
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    padding: 20px 19px 30px 19px;
`;

export const NoUsageReasons = styled.div`
    max-width: 520px;
    .reason {
        float: left;
        width: 50%;
        padding: 10px;
    }
    :after {
        content: '';
        display: table;
        clear: both;
    }
    ${media.mobileDevice`
        .reason {
            width: 100%;
        }
    `}
`;

export const BackButton = styled.div`
    color: #1010eb;
    display: flex;
    cursor: pointer;
    padding: 5px 0 12px;
    margin-left: -6px;
`;
